import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { CallServiceAbstract } from "../call.service";
import { SettingsService } from "../../settings.service";
import { AuthenticationService } from "../../auth/Authentication/authentication.service";
import { Subject } from "rxjs";
import { NotificationService } from "../../notification.service";
import { StateService } from "../../state/state.service";

@Injectable({
  providedIn: "root",
})
export class ProductionShopFloorWorkOrders extends CallServiceAbstract {
  constructor(
    http: HttpClient,
    settings: SettingsService,
    authentication: AuthenticationService,
    notify: NotificationService,
    state: StateService
  ) {
    super(
      http,
      settings,
      authentication,
      notify,
      state,
      "Production_ShopFloor_WorkOrders",
      "Производствени Нареждания"
    );
  }

  public predefineState(state) {
    state.expand.push(
      `Items($expand=Operations($expand=Operation,WorkgroupResource($expand=Resource)),Recipe(
      $expand=Ingredients($select=default,CustomProperty_ProductionAPP_UniqueKey;$expand=Material($select=Name;$expand=MeasurementUnit($select=Code)),Store($select=Id,Name),UsageUnit($select=Code)),
      Product($select=Id,Name,CustomProperty_CheckAvailableQty;$expand=MeasurementUnit($select=Code)),
      Store($select=Id,Name)
      ),Product($select=Id,Name;$expand=ProductGroup($select=CustomProperty_PRODUCTIONAPP_SKIP)))`,
      'ItemIngredients($expand=Material($select=Id,Name,PartNumber))'
    );
    state.expand.push('DocumentType');
    state.expand.push('Prints($expand=DocumentPrintImage($select=Id;$expand=PrintoutLayout($select=Name)))');

    state.select.push('default');
    state.select.push('CustomProperty_No_Order');

    state.filter.filters.push({ field: 'AdjustedDocument', operator: 'eq', value: "null" })
    state.filter.filters.push({ field: 'Void', operator: 'eq', value: "false" })
    return state;
  }

  filter(filter) {
    let obz = new Subject();
    this.query(filter).subscribe(
      (data) => obz.next(data),
      (err) => obz.error(err)
    );
    return obz.asObservable();
  }

  public findByNumber(woNumber) {
    let call = JSON.parse(JSON.stringify(this.stateTemplate));
    call.filter.filters.push({ field: 'DocumentNo', operator: 'eq', value: "'" + woNumber + "'" });
    return this.filter(call)
  }
}
